import {
  CITIES,
  eleventh,
  fourteenth,
  sixteenth,
  TBC,
  thirteenth,
  twelfth,
  twentieth,
} from './cities'

export const ALL_RALLIES = [
  ...eleventh,
  ...twelfth,
  ...thirteenth,
  ...fourteenth,
  ...sixteenth,
  ...twentieth,
  // ...TBC,
]

export function groupByCountry(cityKeys: string[]) {
  const countries: Record<string, string[]> = {}

  cityKeys.forEach((key) => {
    const cityObj = CITIES[key]
    if (!cityObj) return

    const country = cityObj.country || 'Other'

    if (!countries[country]) {
      countries[country] = []
    }
    countries[country].push(key)
  })

  // sort cities inside each country
  Object.keys(countries).forEach((country) => {
    countries[country].sort((a, b) => a.localeCompare(b))
  })

  // return countries in alphabetical order
  const sorted: Record<string, string[]> = {}

  Object.keys(countries)
    .sort((a, b) => a.localeCompare(b))
    .forEach((country) => {
      sorted[country] = countries[country]
    })

  return sorted
}

export const grouped = groupByCountry(ALL_RALLIES)

export function groupByCountryZigzag(cityKeys: string[]) {
  const countries: Record<string, string[]> = {}

  cityKeys.forEach((key) => {
    const cityObj = CITIES[key]
    if (!cityObj) return

    const country = cityObj.country || 'Other'

    if (!countries[country]) {
      countries[country] = []
    }
    countries[country].push(key)
  })

  // sort cities inside each country
  Object.keys(countries).forEach((country) => {
    countries[country].sort((a, b) => a.localeCompare(b))
  })

  // create array of [country, cityKeys] and sort by city count descending
  const sortedByCount = Object.entries(countries).sort((a, b) => b[1].length - a[1].length)

  // zig-zag: odd index first, then even index
  const zigzag: Record<string, string[]> = {}
  const odd: [string, string[]][] = []
  const even: [string, string[]][] = []

  sortedByCount.forEach(([country, keys], index) => {
    if (index % 2 === 0) odd.push([country, keys])
    else even.push([country, keys])
  })
  ;[...odd, ...even].forEach(([country, keys]) => {
    zigzag[country] = keys
  })

  return zigzag
}

export const groupedZigzag = groupByCountryZigzag(ALL_RALLIES)

export function groupByCountryByCount(cityKeys: string[], cities = CITIES) {
  const countries: Record<string, string[]> = {}

  cityKeys.forEach((key) => {
    const cityObj = cities[key]
    if (!cityObj) return

    const country = cityObj.country || 'Other'

    if (!countries[country]) {
      countries[country] = []
    }
    countries[country].push(key)
  })

  // sort cities inside each country alphabetically
  Object.keys(countries).forEach((country) => {
    countries[country].sort((a, b) => a.localeCompare(b))
  })

  // sort countries by number of cities descending
  const sorted: Record<string, string[]> = {}
  Object.entries(countries)
    .sort(([, aCities], [, bCities]) => bCities.length - aCities.length)
    .forEach(([country, cities]) => {
      sorted[country] = cities
    })

  return sorted
}

export const groupedAttendance = groupByCountryByCount(ALL_RALLIES)
